import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { entityButtonsAppear } from 'animations-lib';
import { IIconService } from 'interfaces-lib';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Identity, IdentityStorage } from 'storage-service-lib';
import { EntityTypeLabelPair } from '../../../interfaces/imetadata';
import { ServiceProviderService } from '../../../services/service.provider.service';

@Component({
  selector: 'app-entity-selection',
  templateUrl: './entity-selection.component.html',
  styleUrls: ['./entity-selection.component.scss'],
  animations: [entityButtonsAppear],
  standalone: false,
})
export class EntitySelectionComponent implements OnInit {
  entities$: Observable<EntityTypeLabelPair[]> = of([]);
  loadingEntities = true;

  @Output()
  entitySelectedEvent = new EventEmitter<EntityTypeLabelPair>();

  private readonly iconService: IIconService | undefined;
  private readonly identity: Identity;

  constructor(
    private identityStorage: IdentityStorage,
    private serviceProviderService: ServiceProviderService
  ) {
    const identity = this.identityStorage.get();
    if (!identity) {
      throw new Error('Identity not defined.');
    }
    this.identity = identity;
    this.iconService = serviceProviderService.getIconService(this.identity.namespace);
  }

  ngOnInit() {
    this.entities$ = this.serviceProviderService
      .getMetaDataService(this.identity.namespace)
      .getEntities(this.identity.token, this.identity.namespace)
      .pipe(
      tap(() => {
        this.loadingEntities = false;
      })
    );
  }

  onEntityClick(entity: EntityTypeLabelPair): void {
    this.fireEntitySelected(entity);
  }

  getIcon(type: string) {
    return this.iconService?.getIcon(type);
  }

  private fireEntitySelected(entity: EntityTypeLabelPair): void {
    this.entitySelectedEvent.emit(entity);
  }
}
